<ion-header [translucent]="true" class="header-style">
  <ion-row>
    <ion-col size-sm="4" size-md="2" size-lg="2" size-xs="4" class="p-0">
      <img src="././assets/icon/phiedgeSidebarpoweredbyIcon.jpg" (click)="goToDashboard()" class="logoHeight cp">
    </ion-col>
    <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="p-0">
      <!-- <div class="font_bold fs-20 pt-15">Meri Suraksha | मेरी सुरक्षा</div> -->
    </ion-col>
  </ion-row>
</ion-header>
<ion-content>
  <ion-grid>
    <div class="clear30"></div>
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0 text-center">
        <label class="fs-24 fs_18ForMobile font_medium black_color">The page you are looking for does not exist or you don't have access to it.</label>
        </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
